import { UserBaseInfo } from 'interface/Personal';
import { ExerciseFormat, Grade, SchoolYear, SkillType, Subject } from '../../model/response';
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FeedBackType } from 'interface/FeedBack';
import { getUserInf } from '../../service/userService';
import processError from '../../utils/processError';

interface MasterDataState {
  subjects: Subject[];
  grades: Grade[];
  schoolYears: SchoolYear[];
  exerciseFormats: ExerciseFormat[];
  skillTypes: SkillType[];
  user: UserBaseInfo | null;
  feedBackTypes: FeedBackType[];
}

const initialState: MasterDataState = {
  subjects: [],
  grades: [],
  schoolYears: [],
  exerciseFormats: [],
  skillTypes: [],
  user: null,
  feedBackTypes: [],
};

export const fetchUserInf = createAsyncThunk('masterData/fetchUserInf', async () => {
  try {
    return await getUserInf();
  } catch (err) {
    processError(err);
  }
});

const masterDataSlice = createSlice({
  name: 'masterData',
  initialState,
  reducers: {
    setSubjects: (state, action: PayloadAction<Subject[]>) => {
      state.subjects = action.payload.sort((s1, s2) => {
        if (s1.code === '02') {
          return -1;
        }
        if (s2.code === '02') {
          return 1;
        }
        if (!s1.code) {
          return 1;
        }
        if (!s2.code) {
          return -1;
        }
        return s1.code.localeCompare(s2.code);
      });
    },
    setGrades: (state, action: PayloadAction<Grade[]>) => {
      state.grades = action.payload;
    },
    setSchoolYears: (state, action: PayloadAction<SchoolYear[]>) => {
      state.schoolYears = action.payload;
    },
    setExerciseFormats: (state, action: PayloadAction<ExerciseFormat[]>) => {
      state.exerciseFormats = action.payload;
    },
    setSkillTypes: (state, action: PayloadAction<SkillType[]>) => {
      state.skillTypes = action.payload;
    },
    setUserInfo: (state, action: PayloadAction<UserBaseInfo>) => {
      state.user = action.payload;
    },
    setFeedBackTypes: (state, action: PayloadAction<FeedBackType[]>) => {
      state.feedBackTypes = action.payload;
    },
    clearUserInfo: (state) => {
      state.user = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchUserInf.fulfilled, (state, action) => {
      if (action.payload) {
        state.user = action.payload;
      }
    });
  },
});

export const {
  setSubjects,
  setGrades,
  setSchoolYears,
  setExerciseFormats,
  setSkillTypes,
  clearUserInfo,
  setFeedBackTypes,
} = masterDataSlice.actions;

export default masterDataSlice;
